export enum KazaplanAction {
    Deleted = 'delete' as any,
    Updated = 'update' as any,
    KazaChanged = 'kaza_changed' as any,
    DefinedAsMainPlan = 'defined_as_main_plan' as any,
    MediaListUpdated = 'media_list_updated' as any
}
